import { render, staticRenderFns } from "./flexibleCode.vue?vue&type=template&id=80078042&scoped=true&"
import script from "./flexibleCode.vue?vue&type=script&lang=js&"
export * from "./flexibleCode.vue?vue&type=script&lang=js&"
import style0 from "./flexibleCode.vue?vue&type=style&index=0&id=80078042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80078042",
  null
  
)

export default component.exports